<template>
    <div class="animated fadeIn">
      <mensagem></mensagem>
      <b-alert show variant="warning"> Você possuí <strong>{{QuantidadeDeClienteAtivos}}/{{LimiteDeClienteAtivos}}</strong> clientes ativos </b-alert>
      <b-row v-if="!loadingItens && items.length <= 0">
        <b-col lg="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i> <strong> Clientes </strong>
              <div class="card-header-actions">
              </div>
            </div>
            <div>
              <b-jumbotron header="Nenhum cliente" >
                <b-btn id="botaoAdicionar" variant="primary" @click="$router.push('/cliente/novo')" >Adicionar</b-btn>
              </b-jumbotron>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="!loadingItens && items.length > 0">
        <b-col lg="12">
            <div class=" fright margin-5-bottom" id="botaoAdicionar2">
              <b-button  variant="primary" class="btn-square" @click="$router.push('/cliente/novo')">Adicionar</b-button>
          </div>
        </b-col>
      </b-row>
          <b-row>
        <b-col lg="12">
            <grid-cliente
              :table-data="items" 
              :total-de-paginas="totalDePaginas"
              :action-buttom="true"
              :loading="loadingItens"
              :fields="fields" 
              :acao=acaoCliente
              caption=" Clientes"
              @paginacao="paginacao" 
              @table-remove="removerRegistro" >
            </grid-cliente>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import GridCliente from '@/views/Cliente/GridCliente'
  import Mensagem from '@/base/components/Mensagem'
  
  export default {
    name: 'cliente',
    components: {
      GridCliente,
      Mensagem
    },
    data(){
      return {
        items: [],
        loadingItens: false,
        totalDePaginas: 1,
        QuantidadeDeClienteAtivos:0,
        LimiteDeClienteAtivos:0,
        acaoCliente:true,
        fields: [
          {key: 'nomeCliente', label: 'Razão Social', sortable: true},
          {key: 'fantasiaCliente', label: 'Nome Fantasia', sortable: true},
          {key: 'cnpj', label: 'CNPJ', sortable: true},
          {key: 'possuiLogin', label: 'Gerado usuário', sortable: false},
          {key: 'acoes', label: "Ações", sortable: false, thClass: "center, wd-120-px"}
        ],
      }
    },
    beforeMount(){
      this.getGridData(this.$route.params.id)
    },
    methods: {
      getGridData(pagina){
        var vm = this
        vm.loadingItens = true
        this.$http({url: '/cliente/' +  this.$route.params.id + "/" + vm.$store.getters.getAutenticacao.contaId + "/" + vm.$store.getters.getAutenticacao.usuarioId, method: 'GET' })
          .then(response => {
            vm.loadingItens=false
            vm.items =  response.data.listagem
            vm.totalDePaginas =response.data.paginas
            vm.QuantidadeDeClienteAtivos = response.data.quantidadeDeClientesAtivos
            vm.LimiteDeClienteAtivos = response.data.limiteDeClientesAtivos
            
            if(vm.QuantidadeDeClienteAtivos >= vm.LimiteDeClienteAtivos)
                vm.acaoCliente = false;

        })
        .catch(err => {
            alert(err.message)
        })
      },    
      paginacao(ev){
        this.getGridData(ev)
      },
      removerRegistro(registro){
        var vm = this
        vm.loadingItens = true
        this.$http({url: 'cliente/excluir/' +  registro.id + "/" + vm.$store.getters.getAutenticacao.contaId + "/" + vm.$store.getters.getAutenticacao.usuarioId, method: 'DELETE' })
          .then(response => {
            vm.$store.commit("set_mensagem",{tipo: "success", mensagem: "o acesso do cliente foi excluido com sucesso."})
            vm.$router.go()
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.message})
        })    
      },
    },
  }
  </script>
  